import React from "react"
import {Button, Grid, Header, Segment} from "semantic-ui-react"
import {FormattedMessage, useIntl} from "react-intl"
import {Locale} from "../locale"
import {Dropzone} from "./dropzone"
import {useNavigate} from "react-router"
import {LandingHeader} from "./landing-header"


const examples = { [Locale.EN]: "kennedy", [Locale.ES]: "iglesias", [Locale.PL]: "chopin" }

interface LandingPageProps {
    onCreatorExample: (file: File, event: string) => void
}

export function LandingPage({ onCreatorExample }: LandingPageProps) {
    const navigate = useNavigate()
    const intl = useIntl()

    const handleCreatorExample = async () => {
        const response = await fetch(`/data/gedcom/${intl.locale}/${examples[intl.locale]}.xlsx`)
        const arrayBuffer = await response.arrayBuffer()
        const file = new File([arrayBuffer], `${examples[intl.locale]}.xlsx`, { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
        onCreatorExample(file, "creator_example")
    }

    return (
        <div className="landing">
            <LandingHeader/>
            <Grid stackable stretched columns={2}>

                {/* CREATOR */}
                <Grid.Column id="open-creator">
                    <Segment textAlign="center">
                        {/* Icon */}
                        <img id="creator-icon" src="/assets/gedcom-creator.png" alt="GEDCOM creator"/>
                        {/* Header */}
                        <Header as="h2"><FormattedMessage id="landing.column.creator.label"/></Header>
                        <p><FormattedMessage id="landing.column.creator.desc"/></p>
                        <p><FormattedMessage id="landing.column.example" values={{
                            example: <span onClick={handleCreatorExample}><FormattedMessage id="landing.column.example.placeholder"/></span>
                        }}/></p>
                        {/* Screenshot */}
                        <div id="creator-screenshot">
                            <img src={`/assets/howitworks/${intl.locale}/individuals/individuals1.png`} style={{ display: "block", margin: "0 auto" }} alt="Creator screenshot"/>
                        </div>
                        {/* Open button */}
                        <Button
                            fluid
                            primary
                            style={{ margin: "auto" }}
                            onClick={() => {
                                // Fresh start
                                sessionStorage.clear()
                                localStorage.clear()
                                navigate("/create")
                            }}>
                                <FormattedMessage id="landing.column.creator.button"/>
                        </Button>
                    </Segment>
                </Grid.Column>

                {/* UPLOAD GEDCOM */}
                <Grid.Column id="upload-gedcom">
                    <Segment textAlign="center">
                        {/* Icon */}
                        <img id="gedcom-file" src="/assets/gedcom-file.png" alt="GEDCOM file"/>
                        {/* Header */}
                        <Header as="h2"><FormattedMessage id="landing.column.upload.label"/></Header>
                        <p><FormattedMessage id="landing.column.upload.desc"/></p>
                        <p><FormattedMessage id="landing.column.example" values={{
                            example: <a href={`/data/gedcom/${intl.locale}/${examples[intl.locale]}.ged`} download>
                                <FormattedMessage id="landing.column.example.placeholder"/>
                            </a>
                        }}/></p>
                        {/* Upload area */}
                        <Dropzone/>
                    </Segment>
                </Grid.Column>
            </Grid>

        </div>
    )
}
